import React from "react";
import { useNavigate } from "react-router-dom";

const CaseStudyHeader = ({
  isEdit,
  isSaving,
  isPublishing,
  onSaveDraft,
  onPublish,
  isSaveDisabled,
  caseStudyCreated,
  showPublish = true,
  currentStatus = 'draft'
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/case-studies');
    setTimeout(() => {
      window.location.reload(); 
    }, 100);
  };

  return (

    <header>
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid">
          <button
            className="btn btn-link text-black text-decoration-none d-flex align-items-center font-18"
            onClick={handleClick}
          >
            <span style={{ fontSize: '50px' }}>&larr;</span>
          </button>

          <div className="collapse navbar-collapse" id="navbarExample01">

            <div className="d-flex justify-content-between w-100 align-items-center mb-0">
              <h5 className='mb-0 primary_color'>

              </h5>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <button
                    className="text-decoration-none font-18 primary_color btn btn-primary bg-white md-btn py-2 px-5 ms-4"
                    onClick={onSaveDraft}
                    disabled={isSaving || isSaveDisabled || caseStudyCreated}
                  >
                    {isSaving ? "Saving..." : isEdit ? "Update" : "Save"}
                  </button>
                  {showPublish && (
                    <button
                      className="text-decoration-none font-18  btn btn-primary  md-btn py-2 px-5 ms-4 me-2"
                      onClick={onPublish}
                      disabled={isPublishing}
                    >
                      {isPublishing 
                        ? "Updating..." 
                        : currentStatus === 'published' 
                          ? "Draft" 
                          : "Publish"
                      }
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>

    </header>
  );
};

export default CaseStudyHeader;


